<h1 mat-dialog-title>Supporttyp einstellen</h1>

<div mat-dialog-content>
    <mat-form-field style="width: 100%">
        <mat-label>Support-Typ</mat-label>
        <mat-select [formControl]="supportTypeCtrl" [compareWith]="ticketTypComparator">
            <mat-option *ngFor="let type of supportTypes" [value]="type">{{ type.typ }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div align="end" mat-dialog-actions>
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <button (click)="closeDialog()" [disabled]="isSaving" color="accent" mat-flat-button>Supporttyp Festlegen</button>
</div>
